import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmDialogService } from '../swap-wifi-shared-module/confirm-dialog/confirm-dialog.service';
import { SwapWifiService } from 'src/app/services/swap-wifi.service';
import { PullUpSwapWifiComponent } from '../pull-up-swap-wifi/pull-up-swap-wifi.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-viet-qr',
  templateUrl: './viet-qr.component.html',
  styleUrls: ['./viet-qr.component.scss'],
})
export class VietQRComponent implements OnInit {
  paymentInfo: any;
  showTooltip = false;
  minutes: string;
  seconds: string;
  countdownInterval: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    public swapWifiService: SwapWifiService,
    private confirm: ConfirmDialogService
  ) {
    const a = sessionStorage.getItem('paymentInfo');
    if (a) {
      this.paymentInfo = JSON.parse(a);
    }
    this.minutes = '15';
    this.seconds = '00';
  }

  ngOnInit(): void {
    this.startCountdown(15 * 60);
  }

  startCountdown(totalSeconds: number) {
    this.countdownInterval = setInterval(() => {
      totalSeconds--;

      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      this.minutes = this.formatTime(minutes);
      this.seconds = this.formatTime(seconds);

      if (totalSeconds <= 0) {
        this.router.navigate(['/result-payment'], {
          queryParams: { price: this.paymentInfo?.total_price, status: 'fail', transId: '' },
        });
        clearInterval(this.countdownInterval);
      }
    }, 1000);
  }

  formatTime(time: number): string {
    return time < 10 ? `0${time}` : `${time}`;
  }

  openPopup(type: any, data?: any) {
    const modalRef = this.modalService.open(PullUpSwapWifiComponent, {
      windowClass: 'pull-up-swap-wifi',
    });
    modalRef.componentInstance.typePopup = type;
    modalRef.componentInstance.dataPopup = data;
    modalRef.componentInstance.modalEvent.subscribe((res: any) => {
      return modalRef.result;
    });
  }

  toggleTooltipPayment() {
    this.showTooltip = !this.showTooltip;
  }

  downloadImage(url: any) {
    fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.blob();
    })
    .then(blob => {
      let blobUrl = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.download = url.split('/').pop();
      a.href = blobUrl;
      document.body.appendChild(a);
      a.click();
      a.remove();
    })
    .catch(error => {
      console.error('There has been a problem with your fetch operation:', error);
    });
  }

}
